import { SportAbrv } from "@utils";

export const tbodyColspanMax = 11;

export function calculateTableBodyColspan(abrv: string): number {
	let tbodyColspan = 0;
	switch (abrv) {
		case SportAbrv.SQUASH:
		case SportAbrv.MMA:
		case SportAbrv.DARTS:
		case SportAbrv.TABLE_TENNIS:
		case SportAbrv.BOXING:
		case SportAbrv.BOWLS:
		case SportAbrv.CRICKET:
		case SportAbrv.SNOOKER:
			tbodyColspan = 6;
			break;
		case SportAbrv.BASEBALL:
		case SportAbrv.GOLF:
		case SportAbrv.MOTORSPORT:
		case SportAbrv.PESAPALLO:
		case SportAbrv.BEACH_SOCCER:
		case SportAbrv.ESOCCER:
		case SportAbrv.BANDY:
			tbodyColspan = 7;
			break;
		case SportAbrv.FUTSAL:
		case SportAbrv.HANDBALL:
		case SportAbrv.RUGBY:
		case SportAbrv.SOCCER:
			tbodyColspan = 8;
			break;
		case SportAbrv.AUSSIE_RULES:
		case SportAbrv.ICE_HOCKEY:
		case SportAbrv.FIELD_HOCKEY:
		case SportAbrv.AMERICAN_FOOTBALL:
			tbodyColspan = 10;
			break;
		case SportAbrv.BEACH_VOLLEY:
		case SportAbrv.BADMINTON:
		case SportAbrv.BASKETBALL:
		case SportAbrv.TENNIS:
		case SportAbrv.WATERPOLO:
		case SportAbrv.VOLLEYBALL:
		case SportAbrv.FLOORBALL:
			tbodyColspan = 11;
			break;
		default:
			tbodyColspan = 7;
			break;
	}

	return tbodyColspan;
}
